export default __webpack_public_path__ + "fonts/32fb1de83ed9b1568ceecdf3bcf93023.ttf";